import { render, staticRenderFns } from "./AnnouncementExternal.html?vue&type=template&id=705b2034&scoped=true&"
import script from "./AnnouncementExternal.vue?vue&type=script&lang=js&"
export * from "./AnnouncementExternal.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementExternal.scss?vue&type=style&index=0&id=705b2034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705b2034",
  null
  
)

export default component.exports